import { useState, useId } from "react";

export const PLESSI = ["INFANZIA", "PRIMARIA", "SECONDARIA", "COMUNITA"];
export const TIPI_CAUSALE = [
  { id: 1, l: "Fatture Acquisto" },
  { id: 2, l: "Nota di Credito" },
  { id: 3, l: "Operazione Extra" },
];

export const fmt = (n) => Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const isoToDmy = (iso) => { if (!iso || !iso.includes("-")) return ""; const [y,m,d] = iso.split("-"); return `${d}/${m}/${y}`; };
export const dmyToIso = (dmy) => { if (!dmy || !dmy.includes("/")) return ""; const [d,m,y] = dmy.split("/"); return `${y}-${m.padStart(2,"0")}-${d.padStart(2,"0")}`; };

/** Regola segno: 1=Fattura→+, 2=NotaCredito→−, 3=Extra→user-chosen (default +). */
export const segnoForTipo = (prot_tipo_id, current) => {
  const t = Number(prot_tipo_id);
  if (t === 1) return "+";
  if (t === 2) return "-";
  return current === "-" ? "-" : "+";
};

export const Field = ({ label, value, onChange, type = "text", testid, big }) => {
  const uid = useId();
  // Per disabilitare DEFINITIVAMENTE l'autofill di Chrome per "Card Number",
  // usiamo type="search" (esente dalle heuristic di credit-card) + un honeypot
  // password nascosto subito prima, che attira l'eventuale autofill.
  const inputType = type === "text" ? "search" : type;
  return (
    <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
      <label style={{ width: 110, fontSize: 11, fontWeight: 700, color: "#37474f" }}>{label}</label>
      {/* Honeypot: cattura autofill */}
      <input type="password" tabIndex={-1} autoComplete="new-password"
        aria-hidden="true"
        style={{ position: "absolute", left: -9999, top: -9999, width: 1, height: 1, opacity: 0, pointerEvents: "none" }} />
      <input type={inputType} value={value} onChange={e => onChange(e.target.value)} data-testid={testid}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        data-form-type="other"
        data-lpignore="true"
        data-1p-ignore="true"
        results="0"
        name={`fld-${uid.replace(/:/g, "")}`}
        id={`fld-${uid.replace(/:/g, "")}`}
        aria-label={label}
        style={{ flex: 1, padding: "4px 8px", border: "1px solid #888", fontSize: big ? 14 : 12, fontFamily: type === "number" ? "monospace" : undefined, fontWeight: big ? 700 : 400, textAlign: type === "number" ? "right" : "left", appearance: "none" }} />
    </div>
  );
};

export const FieldDate = ({ label, value, onChange, testid, compact, readOnly, labelWidth }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
    <label style={{ width: labelWidth != null ? labelWidth : 110, fontSize: 11, fontWeight: 700, color: "#37474f" }}>{label}</label>
    <input type="date" value={dmyToIso(value)} onChange={e => onChange && onChange(isoToDmy(e.target.value))} data-testid={testid}
      readOnly={!!readOnly}
      tabIndex={readOnly ? -1 : 0}
      style={{
        flex: compact ? undefined : 1,
        width: compact ? 140 : undefined,
        padding: "4px 8px",
        border: "1px solid #888",
        fontSize: 12,
        background: readOnly ? "#eceff1" : "white",
        color: readOnly ? "#455a64" : "#000",
        cursor: readOnly ? "not-allowed" : "auto",
      }} />
  </div>
);

export const BigField = ({ label, value, editable, onChange, testid, color, colorDelta }) => {
  let txtColor = color || "#37474f";
  if (colorDelta != null) txtColor = Math.abs(colorDelta) < 0.01 ? "#1b5e20" : "#c62828";

  const formatIt = (v) => {
    const n = Number(v);
    if (!Number.isFinite(n) || n === 0) return "";
    return n.toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  const parseIt = (raw) => {
    const cleaned = String(raw).replace(/[^\d,-]/g, "").replace(",", ".");
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : 0;
  };

  const [focused, setFocused] = useState(false);
  const [raw, setRaw] = useState("");
  const displayValue = focused ? raw : formatIt(value);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: "#666", letterSpacing: 0.5 }}>{label}</div>
      {editable ? (
        <div style={{ display: "flex", alignItems: "center", border: "3px solid #0d47a1", background: "#bbdefb", height: 64, boxSizing: "border-box", padding: "0 16px" }}>
          <span style={{ fontSize: 36, fontFamily: "monospace", fontWeight: 800, color: txtColor, marginRight: 8, lineHeight: 1 }}>€</span>
          <input type="text" inputMode="decimal" size="1"
            value={displayValue}
            onFocus={() => { setRaw(value ? String(value).replace(".", ",") : ""); setFocused(true); }}
            onChange={e => { const v = e.target.value.replace(/[^\d,]/g, ""); setRaw(v); onChange(parseIt(v)); }}
            onBlur={() => setFocused(false)}
            data-testid={testid}
            className="pn-bigfield-input"
            placeholder="0,00"
            style={{ flex: 1, minWidth: 0, width: "100%", padding: 0, border: "none", outline: "none", fontSize: 36, fontFamily: "monospace", fontWeight: 800, textAlign: "right", color: txtColor, background: "transparent", lineHeight: 1, height: "100%" }} />
        </div>
      ) : (
        <div data-testid={testid}
          style={{ padding: "0 14px", border: "2px solid #ddd", fontSize: 22, fontFamily: "monospace", fontWeight: 800, textAlign: "right", color: txtColor, background: "white", lineHeight: 1, height: 44, boxSizing: "border-box", display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
          € {fmt(value)}
        </div>
      )}
    </div>
  );
};

export const Step = ({ n, title, done, children }) => (
  <div style={{ border: "1px solid #ddd", padding: 10, background: done ? "#f1f8e9" : "#fafafa" }}>
    <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 8, color: done ? "#1b5e20" : "#37474f", display: "flex", alignItems: "center", gap: 8 }}>
      <span style={{ background: done ? "#1b5e20" : "#0288d1", color: "white", width: 22, height: 22, display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: "50%", fontSize: 12 }}>{done ? "✓" : n}</span>
      {title}
    </div>
    <div>{children}</div>
  </div>
);

export const Lab = ({ children }) => (
  <div style={{ fontSize: 11, fontWeight: 700, color: "#37474f", marginBottom: 4 }}>{children}</div>
);
